import SearchAlertsContainer from '../../SearchAlerts/components/Boats';
import React from 'react';
import PropTypes from 'prop-types';
import { shouldSeeSearchAlert } from '../FilterHelpers/utilFilters';

const FilterSearchAlert = ({context, match, active, makeModel, seoMakeInfo, position, currentLanguage }) => {
  const showSearchAlert = shouldSeeSearchAlert(context, position, currentLanguage);
  if (!showSearchAlert) {
    return null;
  }
  return (
    <SearchAlertsContainer
      match={match}
      eventCategory="above search filter"
      active={active}
      makeModel={makeModel}
      seoMakeInfo={seoMakeInfo}
    />
  );
};

FilterSearchAlert.propTypes = {
  match: PropTypes.object,
  active: PropTypes.object,
  position: PropTypes.string,
  currentLanguage: PropTypes.string,
  context: PropTypes.object,
  makeModel: PropTypes.arrayOf(
    PropTypes.shape({
      /** Make formatted name */
      value: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      model: PropTypes.arrayOf(
        PropTypes.shape({
          /** Model formatted name */
          value: PropTypes.string.isRequired,
          count: PropTypes.number.isRequired
        })
      )
    })
  ),
  seoMakeInfo: PropTypes.shape({
    make: PropTypes.string.isRequired,
    seoMakeName: PropTypes.string.isRequired
  }),
};

export { FilterSearchAlert };
